export type EmojiUnicode = "😊" | "😋" | "🧐" | "🤔" | "😎" | "😬" | "😮" | "😻" | "🦊"
export type UserRole = "student" | "teacher" | "elder" | "other"

interface EmojiCopy { name: string; description: string }

export const EMOJI_ORDER: EmojiUnicode[] = ["😊", "😋", "🧐", "🤔", "😎", "😬", "😮", "😻", "🦊"]

export const ROLE_LABEL: Record<UserRole, string> = {
  student: "Skolēns",
  teacher: "Skolotājs",
  elder: "Vecāks",
  other: "Cits"
}

const EMPTY: EmojiCopy = { name: "", description: "" }

export const emojiVariants: Record<EmojiUnicode, Record<UserRole, EmojiCopy>> = {
  "😊": {
    student: { name: "Smaidīgais skolēns", description: "Smaida, jo viņam viss izpildīts" },
    teacher: { name: "Smaidīgais skolotājs", description: "Smaida, jo mīl savu darbu" },
    elder: EMPTY,
    other: EMPTY
  },
  "😋": {
    student: { name: "Vienmēr izsalcis", description: "Gaida pusdienas, nevar pamācīties" },
    teacher: { name: "Jautrais skolotājs", description: "Patīk izjokot skolēnus" },
    elder: EMPTY,
    other: EMPTY
  },
  "🧐": {
    student: { name: "Gudrītis", description: "Zina atbildes, kad pārējie nezina" },
    teacher: { name: "Gudrais skolotājs", description: "Zina atbildes, kad pārējie nezina" },
    elder: EMPTY,
    other: EMPTY
  },
  "🤔": {
    student: { name: "Domulīts", description: "Stundās skatās pa logu, līdz izdomā pareizo atbildi" },
    teacher: { name: "Skeptiskais skolotājs", description: "Pamatīgi jāpārliecinās, pirms ievieš ko jaunu" },
    elder: EMPTY,
    other: EMPTY
  },
  "😎": {
    student: { name: "Stilīgais", description: "Svarīgi izskatīties labi, kad pilda testu" },
    teacher: { name: "Stilīgais skolotājs", description: "Skolēni vēlas viņam līdzināties un kopā pavadīt laiku" },
    elder: EMPTY,
    other: EMPTY
  },
  "😬": {
    student: { name: "Aizmārša", description: "Stundās neseko līdzi un nekad nezina, kas jādara" },
    teacher: { name: "Aizmāršīgais skolotājs", description: "Bieži aizmirst savas paroles" },
    elder: EMPTY,
    other: EMPTY
  },
  "😮": {
    student: { name: "Šokēts", description: "Bail no mājasdarbiem" },
    teacher: { name: "Šokētais skolotājs", description: "Patīkami pārsteigts par skolēnu rezultātiem" },
    elder: EMPTY,
    other: EMPTY
  },
  "😻": {
    student: { name: "Somas fans", description: "Jūtas ļoti laimīgs, kad mājasdarbs uzdots Somā" },
    teacher: { name: "Somas fans", description: "Jūtas ļoti laimīgs tad, kad var uzdot mājasdarbu Somā" },
    elder: EMPTY,
    other: EMPTY
  },
  "🦊": {
    student: { name: "Viltnieks", description: "Zina, kā atrast pareizo atbildi" },
    teacher: { name: "Viltnieks", description: "Zina, kā atrast pareizo atbildi" },
    elder: EMPTY,
    other: EMPTY
  }
}
